(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-article-sfs"]) return;
  try {
    
  const audio = document.querySelector('audio');

    const curTime = document.getElementById('ap_current_time');
    const durTime = document.getElementById('ap_duration');

    const calcTime =(secs) => {
        const mm = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const ss = seconds < 10 ? `0${seconds}` : `${seconds}`;

        return `${mm}:${ss}`;
    };

    const playPause = document.getElementById('ap_play_pause');
    const playButton = document.getElementById('play_button');
    const pauseButton = document.getElementById('pause_button');

    const seeker = document.getElementById('ap_seeker');

    const mute = document.getElementById('ap_audio');
    const volume = document.getElementById('ap_volume_slider');

    const muteOff = document.getElementById('mute_off_button');
    const muteOn = document.getElementById('mute_button');

    audio.onloadedmetadata = () => {
        curTime.innerHTML = calcTime(audio.currentTime);
        durTime.innerHTML = calcTime(audio.duration);
    };

    audio.ontimeupdate = () => {
        seeker.value = Math.floor(audio.currentTime);

        curTime.textContent = calcTime(seeker.value);

        if (audio.currentTime === audio.duration) {
            console.log('audio ended');

            pauseButton.classList.add('inactive');
            playButton.classList.remove('inactive');
            audio.currentTime = 0;

            curTime.innerHTML = audio.currentTime;
        }
    };

    playPause.addEventListener('click', () => {
        console.log('play pause toggle')

        if(audio.paused) {
            audio.play();
            playButton.classList.add('inactive');
            pauseButton.classList.remove('inactive');
        } else {
            audio.pause();
            pauseButton.classList.add('inactive');
            playButton.classList.remove('inactive');
        }
    });

    seeker.addEventListener('change', () => {
        console.log('seeking track');
        
        seeker.setAttribute('max', Math.floor(audio.duration));
        audio.currentTime = seeker.value;
    });

    mute.addEventListener('click', () => {
        console.log('mute toggle');
        
        if (audio.muted) {
            audio.muted = false;
            muteOff.classList.remove('inactive');
            muteOn.classList.add('inactive');
            volume.removeAttribute('disabled');
        } else {
            audio.muted = true;
            muteOn.classList.remove('inactive');
            muteOff.classList.add('inactive');
            volume.setAttribute('disabled', '');
        }
    });

    volume.addEventListener('change', () => {
        console.log('volume slider')
        
        audio.volume = volume.value / 100;
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article"]) return;
  try {
    
  const audio = document.querySelector('audio');

    const curTime = document.getElementById('ap_current_time');
    const durTime = document.getElementById('ap_duration');

    const calcTime =(secs) => {
        const mm = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const ss = seconds < 10 ? `0${seconds}` : `${seconds}`;

        return `${mm}:${ss}`;
    };

    const playPause = document.getElementById('ap_play_pause');
    const playButton = document.getElementById('play_button');
    const pauseButton = document.getElementById('pause_button');

    const seeker = document.getElementById('ap_seeker');

    const mute = document.getElementById('ap_audio');
    const volume = document.getElementById('ap_volume_slider');

    const muteOff = document.getElementById('mute_off_button');
    const muteOn = document.getElementById('mute_button');

    audio.onloadedmetadata = () => {
        curTime.innerHTML = calcTime(audio.currentTime);
        durTime.innerHTML = calcTime(audio.duration);
    };

    audio.ontimeupdate = () => {
        seeker.value = Math.floor(audio.currentTime);

        curTime.textContent = calcTime(seeker.value);

        if (audio.currentTime === audio.duration) {
            console.log('audio ended');

            pauseButton.classList.add('inactive');
            playButton.classList.remove('inactive');
            audio.currentTime = 0;

            curTime.innerHTML = audio.currentTime;
        }
    };

    playPause.addEventListener('click', () => {
        console.log('play pause toggle')

        if(audio.paused) {
            audio.play();
            playButton.classList.add('inactive');
            pauseButton.classList.remove('inactive');
        } else {
            audio.pause();
            pauseButton.classList.add('inactive');
            playButton.classList.remove('inactive');
        }
    });

    seeker.addEventListener('change', () => {
        console.log('seeking track');
        
        seeker.setAttribute('max', Math.floor(audio.duration));
        audio.currentTime = seeker.value;
    });

    mute.addEventListener('click', () => {
        console.log('mute toggle');
        
        if (audio.muted) {
            audio.muted = false;
            muteOff.classList.remove('inactive');
            muteOn.classList.add('inactive');
            volume.removeAttribute('disabled');
        } else {
            audio.muted = true;
            muteOn.classList.remove('inactive');
            muteOff.classList.add('inactive');
            volume.setAttribute('disabled', '');
        }
    });

    volume.addEventListener('change', () => {
        console.log('volume slider')
        
        audio.volume = volume.value / 100;
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-items"]) return;
  try {
    
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function(e) {
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-img"]) return;
  try {
    
if (window.innerWidth > 750) {
  const hero = document.getElementById("hero-img"); // get a reference to the element
  const bars = document.getElementById("bars"); 
  const logo = document.getElementById("static-logo");
  const search = document.getElementById("search");
  const cart = document.getElementById("cart");
  const cartLink = cart.getElementsByTagName("a");
  
  let heroHeight = hero.offsetHeight; // get the height of the element
  
  const priColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color');
  const secColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-color');
  const tetColor = getComputedStyle(document.documentElement).getPropertyValue('--tetriary-color');
  
  window.addEventListener('resize', function() {
    heroHeight = hero.offsetHeight;
    console.log(heroHeight);
  });
  
console.log(heroHeight);
  
  window.onscroll = function() {
    if (window.pageYOffset > hero.offsetTop + heroHeight) { //scrolled beyond element
      bars.style.fill=priColor;
      bars.style.filter="none";
      logo.style.fill=priColor;
      logo.style.filter="none";
      for (let i = 0; i < cartLink.length; i++) {
        cartLink[i].style.color = priColor;
        cartLink[i].style.filter = "none";
      }
    } else { //scrolled above element
      bars.style.fill="";
      bars.style.filter="";
      logo.style.fill="";
      logo.style.filter="";
      for (let i = 0; i < cartLink.length; i++) {
        cartLink[i].style.color = "";
        cartLink[i].style.filter = "";
      }
    }
  };
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-header"]) return;
  try {
    
  function centerElement() {
    const myDiv = document.getElementById("hero-img");
    const centered = document.getElementById("home-header-nav");
    const windowHeight = window.innerHeight;
    const divHeight = myDiv.offsetHeight;
    const centeredHeight = centered.offsetHeight;
    let offset;
  
    if (divHeight <= windowHeight) {
      offset = (divHeight - centeredHeight) / 2.25;
    } else {
      offset = (windowHeight - centeredHeight) / 2.25;
    }
  
    centered.style.position = "absolute";
    centered.style.top = offset + "px";
  }
  
  window.onload = centerElement;
  window.onresize = centerElement;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-header"]) return;
  try {
    
  if (window.innerWidth >= 750) {
    
    const handleHeroColors = () => {
      const hero = document.getElementById("hero-img");
      const bars = document.getElementById("bars");
      const logo = document.getElementById("static-logo");

      if (hero && bars && logo) {
        // Calculate the bottom of the hero, then subtract 10 pixels
        const actualBottom = hero.offsetTop + hero.offsetHeight;
        const triggerPoint = actualBottom - 10; 
        
        const scrollPos = window.pageYOffset;

        if (scrollPos <= triggerPoint) {
          // --- ABOVE TRIGGER (Force White) ---
          bars.style.fill = "#FFFEFE";
          logo.style.fill = "#FFFEFE";
          
          bars.querySelectorAll('path').forEach(p => p.style.fill = "#FFFEFE");
          logo.querySelectorAll('path').forEach(p => p.style.fill = "#FFFEFE");
        } else {
          // --- BELOW TRIGGER (Revert to CSS) ---
          bars.style.fill = "";
          logo.style.fill = "";
          
          bars.querySelectorAll('path').forEach(p => p.style.fill = "");
          logo.querySelectorAll('path').forEach(p => p.style.fill = "");
        }
      }
    };

    window.addEventListener('load', handleHeroColors);
    window.addEventListener('scroll', handleHeroColors);
    window.addEventListener('resize', handleHeroColors);
  }

  } catch(e) { console.error(e); }
})();
})();
